import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'broadcasts';
var crud = createCrud(basePath);
export var useBroadcastRemoveById = crud.makeRemoveById('{basePath}/{id}');